import { useGetOne } from 'react-admin';

export function useBillingDetails(userId) {
  return useGetOne(
    'users',
    { id: `${userId}/billing-details` },
    { enabled: !!userId }
  );
}

export function useCareCreditDetails(userId, shouldFetchCareCreditDetails = false) {
  return useGetOne(
    'users',
    { id: `${userId}/care-credit-details` },
    { enabled: shouldFetchCareCreditDetails && !!userId }
  );
}
